<template>
  <div class="bg-default wrapper">
    <!-- Navbar -->
    <base-nav
      class="navbar-top navbar-horizontal navbar-light bg-white"
      containerClasses="py-1 container"
      expand
      :showToggleButton="false"
    >
      <span slot="brand" class="navbar-brand m-auto">
        <img
          src="/img/brand/logo_stars_black.png"
          @click="openLink('https://starsaceleradora.com.br/')"
          title="Stars Aceleradora"
          class="cursor-pointer"
        />
      </span>
    </base-nav>
    <!-- Page content -->
    <div class="container main-content">
      <slide-y-up-transition mode="out-in" origin="center top">
        <router-view></router-view>
      </slide-y-up-transition>
    </div>
  </div>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: "blank-layout",
  components: {
    SlideYUpTransition,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    openLink(link) {
      window.open(link, "_blank", "noreferrer noopener").focus();
    },
  },
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.wrapper {
  min-height: 100%;
  min-width: 100%;
  position: absolute;
}

.bg-dark-green {
  background-color: seagreen !important;
}
.navbar-horizontal .navbar-brand img {
  height: 73px;
}
</style>
<style>
html {
  position: relative;
  min-height: 100%;
}
</style>
